import { useCallback, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { cleanAuth } from '../../utils/storage'

function FrontendAuth(props) {
  const navigate = useNavigate()
  const { config, children } = props
  const [hasPermission, setHasPermission] = useState(null)

  const judgeTime = useCallback(() => {
    let time = localStorage.getItem('time')
    let nowTime = new Date().getTime()
    let second = parseInt((nowTime - time) / 1000)
    return second < 1800
  }, [])

  const checkPermission = useCallback(() => {
    const isTimeValid = judgeTime()
    if (!isTimeValid) cleanAuth()
    const hasPermission =
      localStorage.getItem('accountId') !== null && isTimeValid
    setHasPermission(hasPermission)
  }, [judgeTime])

  useEffect(() => {
    checkPermission()
  }, [checkPermission])

  // 404 page
  useEffect(() => {
    if (config) return
    navigate('/login', { replace: true })
  }, [config, navigate])

  // login redirect
  useEffect(() => {
    if (!config || hasPermission === null) return
    if (config.path === '/login' && hasPermission) {
      navigate('/home', { replace: true })
    }
  }, [config, hasPermission, navigate])

  // no permission redirect
  useEffect(() => {
    if (!config || hasPermission === null) return
    if (config.needAuth && !hasPermission) {
      navigate('/login', { replace: true })
    }
  }, [config, hasPermission, navigate])

  return children || null
}

export default FrontendAuth
